export default "<p>edit-email-type works!</p>\n"